<template>
  <div class="entire-layout-wrapper">
    <header-title :title="$t('auth.signIn')" />
    <!-- ローディング -->
    <Progress v-if="isProcessing.flag" :title="isProcessing.message"></Progress>
    <!-- ログインフォーム -->
    <div v-else class="make-account-wrapper">
      <form>
        <!--email 入力-->
        <div class="input-field">
          <label for="email" class="input-label">
            {{ $t("common.mail") }}
          </label>
          <input
            type="email"
            maxlength="128"
            class="form-control"
            v-model="email"
            v-validate="'email'"
            v-bind:class="{ error: errors.has('email') }"
            name="email"
          />
        </div>
        <p class="invalid-text" v-if="errors.has('email')">
          {{ $t("auth.incorrectEmail") }}
        </p>
        <!--password 入力-->
        <div class="input-field">
          <label for="password" class="input-label">
            {{ $t("common.password") }}
          </label>
          <input
            type="password"
            maxlength="128"
            class="form-control"
            v-model="password"
            v-validate="'required'"
            name="password"
            placeholder="6桁以上"
            v-bind:class="{ error: errors.has('password') }"
          />
        </div>
        <p class="invalid-text" v-if="errors.has('password')">
          {{ $t("auth.incorrectPassword") }}
        </p>

        <router-link to="/Reset">
          <div>{{ $t("auth.forgotPassword") }}</div>
        </router-link>

        <p class="invalid" v-if="isDenied">
          {{ $t("auth.incorrectEmailPassword") }}
        </p>

        <next-button
          :label="$t('auth.signIn')"
          @click.prevent="onSignup"
          :disabled="!isDisabled"
          class="next-button"
        />
      </form>
    </div>
  </div>
</template>

<script>
import { firebase, auth } from "../firebase";
import HeaderTitle from "../design/HeaderTitleSlot";
import NextButton from "../components/atoms/NextButton";
import store from "../store";
import Progress from "../components/atoms/Progress";

export default {
  components: {
    HeaderTitle,
    NextButton,
    Progress,
  },
  data() {
    return {
      isDenied: false,
      isProcessing: {
        flag: false,
        message: "",
      },
      email: "",
      password: "",
    };
  },
  computed: {
    isDisabled: function() {
      return (
        this.email &&
        this.password &&
        Object.keys(this.fields).some((key) => this.fields[key].valid)
      );
    },
  },
  methods: {
    async onSignup() {
      // ローディング開始
      //this.isProcessing = true;
      this.$set(this.isProcessing, "flag", true);
      this.$set(this.isProcessing, "message", "ログイン中...");
      // エラ-メッセージの初期化
      this.isValidCoupon = false;

      try {
        const { user } = await firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password);

        if (user.emailVerified) {
          // FireBase Auth チェック
          const checkUser = firebase.functions().httpsCallable("checkUser");
          await checkUser();
          // Firebase 認証が完了している場合はユーザ情報を取得する
          const { uid } = auth.currentUser;
          await store.dispatch("users/fetchUserFromFirebase", uid);

          // ログイン後の遷移
          if (store.state.users.nickname) {
            this.$router.push({ name: "notebook" });
          } else {
            this.$router.push({ name: "complete" });
          }
        } else {
          this.isDenied = true;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log("ERROR", error);
        this.isDenied = true;
      } finally {
        this.$set(this.isProcessing, "flag", false);
      }
    },
  },
};
</script>

<style scoped>
/*全体のレイアウトの余白調整 スクリーンサイズに合わせて調整*/
@media screen and (min-width: 1024px) {
  .entire-layout-wrapper {
    width: 650px; /* default 65vw */
    align-content: center;
    align-items: center;
    margin: 0 auto;
  }
  .input-label {
    font-size: 14px;
    font-weight: bold;
    text-align: left;
  }
}

@media screen and (min-width: 800px) and (max-width: 1023px) {
  .entire-layout-wrapper {
    width: 65vw; /* default 65vw */
    align-content: center;
    align-items: center;
    margin: 0 auto;
  }
  .input-label {
    font-size: 11px;
    font-weight: bold;
    text-align: left;
  }
}

@media screen and (max-width: 799px) {
  .entire-layout-wrapper {
    width: 60vw; /* default 65vw */
    align-content: center;
    align-items: center;
    margin: 0 auto;
  }
  .input-label {
    font-size: 11px;
    font-weight: bold;
    text-align: left;
  }
}

.make-account-wrapper {
  border: 2px solid #d7d7d7;
  border-radius: 10px;
  width: 100%;
  padding: 40px;
  margin-top: 10px;
}
.form-control {
  border-radius: 5px;
  border: 1px solid #ced4da;
  padding: 5px;
  height: 30px;
  font-size: calc(100% + 0.4vw);
}
.input-field {
  display: grid;
  align-items: center;
  gap: 20px;
  margin-bottom: 40px;
  grid-template-columns: 1fr 4.5fr;
}
.justify-content-md-center {
  margin-top: 20px;
}
.next-button {
  margin-top: 20px;
}
/* エラー表記用 */
.invalid {
  color: red;
}
.invalid-text {
  color: red;
  transform: translateY(-150%);
  vertical-align: top;
  height: inherit;
}
/*validation error 発生領域表示*/
.form-control.error {
  border-color: #e84444;
}
/*正常系*/
.form-control.pass {
  border-color: blue;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(232, 68, 68, 0.6);
}
::placeholder {
  vertical-align: middle;
  font-size: 13pt;
}
/* 入力フォーム用 */
/* .input-label {
  font-size: 15px;
  font-weight: bold;
  text-align: left;
} */
</style>
